export default "__VITE_ASSET__BP2MngIx__"